<template>
  <a :href="link" target="_blank" class="button" :title="label">
    <span>{{ label }}</span>
  </a>
</template>

<script>
export default {
  name: 'ExternalLink',
  props: {
    arrow: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },
}
</script>
